import {prepareFormData} from '@/store/modules/helpers/prepareFormData'
import { $payedAPI, $feedbackAPI, apiList } from '@/api'

/**
 * New PayedCourses API
 *
 */
export default {
    state: {
        isActiveConfirm: false,
        isRegDrawerType: true,
        drawerType: 'training', // ** cases: `training` or `professional` - this type names recieved from backend
        targetCourse: null,
        userContract: null,
        // showcaseCourses: null,
        status: {
            contractLoading: false
        },
        coursetype: {
            online: 'Онлайн курс',
            training: 'Программа повышения квалификации',
            professional: 'Профессиональная переподготовка',
            other: 'Другое'
        },
        coursedocument: {
            'training-certificate': 'удостоверение о повышении квалификации',
            'professional-diploma': 'диплом о профессиональной переподготовке',
            certificate: 'сертификат',
            'worker-certificate': 'Свидетельство о профессии рабочего'
        },
        backendStatus: 'down'
    },

    getters: {
        isActiveConfirm: (state) => {
            return state.isActiveConfirm
        },
        paidcourse: state => state.targetCourse,
        usercontract: state => state.userContract?.data,
        getBackendStatus: state => state.backendStatus,
        professionalContractLoading: state => state.status.contractLoading
    },

    mutations: {
        setIsActiveConfirm(state, value) {
            state.isActiveConfirm = value
        },
        setDrawerType(state, value) {
            if (typeof value === 'string') {
                state.drawerType = value
            } else {
                state.isRegDrawerType = value // ** !!! bool value DEPRECATED
            }
        },
        setPaidCourse(state, value) {
            state.targetCourse = value
        },
        setUserContract(state, value) {
            // debugger
            // ** `data: false` - indicates contract is loaded but not exists, `data: undefined` - contract was not loaded
            state.userContract = value ? {data: value.data ?? false, message: value.message} : null
        },
        setState(state, payload) {
            if (typeof payload !== 'object') {
                return
            }
            for (const key in payload) {
                state[key] = Object.assign(state[key] || {}, payload[key])
            }
        },
        setBackendStatus(state, value) {
            state.backendStatus = value
        }
    },

    actions: {
        /**
         *
         */
        getUserContract({state, commit}, payload = null) {
            // debugger
            if (state.status.contractLoading) return state.status.contractLoading

            return state.status.contractLoading = new Promise(async (resolve, reject) => {
                try {
                    const resp = await $payedAPI({
                        method: apiList.payedcourses.getUserContract.method,
                        url: apiList.payedcourses.getUserContract.action,
                        data: payload || undefined
                    })
                    commit('setUserContract', resp.data)
                    resolve(resp.data)
                } catch (err) {
                    reject(err)
                } finally {
                    state.status.contractLoading = false
                }
            })
        },

        /**
         *
         */
        getUserContractExtendedInfo({state}) {
            if (state.status.contractLoading) return state.status.contractLoading

            return state.status.contractLoading = new Promise(async (resolve, reject) => {
                try {
                    const resp = await $payedAPI({
                        method: apiList.payedcourses.getUserContractExtendedInfo.method,
                        url: apiList.payedcourses.getUserContractExtendedInfo.action
                    })
                    resolve(resp.data?.data)
                } catch (err) {
                    state.status.contractLoading = false
                    reject(err)
                } finally {
                    state.status.contractLoading = false
                }
            })
        },

        // getShowcase({state, commit}) {
        //     if (state.status.showcaseLoading) return state.status.showcaseLoading

        //     return state.status.showcaseLoading = new Promise((resolve, reject) => {
        //         $payedAPI({
        //             method: apiList.payedcourses.getShowcase.method,
        //             url: apiList.payedcourses.getShowcase.action,
        //             params: {$expand: ['one2one']}
        //         })
        //             .then(resp => {
        //                 resolve(resp.data)
        //             }).catch(err => {
        //             reject(err)
        //         })
        //     })
        // },

        getData({state, commit}, {table, params, id}) {
            let url = `table/${table}`
            if (id) {
                url += `/${id}`
            }
            return $payedAPI({
                method: 'GET',
                url,
                params: Object.assign({$expand: ['one2one']}, params)
            }).then(resp => resp.data)
        },

        openutmnSendEmail(_, payload) {
            return $payedAPI({
                method: 'POST',
                url: `openutmn/stayconnectedEmail`,
                data: payload
            }).then(resp => resp.data)
        },

        feedbackFormSendEmail({ state, commit, getters }, payload) {
            const baseURL = import.meta.env.VITE_APP_FEEDBACK_BASEURL || this.getters.getCustomInformation.customBackendAddress
            // console.log(baseURL)
            // debugger
            return $feedbackAPI({
                method: 'POST',
                // baseURL: this.getters.getCustomInformation.customBackendAddress,
                baseURL,
                // url: `web/feedbackFormSendEmail`,
                url: `/api/web/feedback`,
                headers: {
                    'Content-Type': 'multipart/form-data; boundary=---011000010111000001101001',
                    // 'Authorization': 'token 1b9bbfc1-328f-46d0-9026-7ad362fb9492'
                },
                data: prepareFormData(payload)
            }).then(resp => resp.data)
        },

        /**
         *
         */
        setIsActiveConfirm({commit}, value) {
            commit('setIsActiveConfirm', value)
        },

        /**
         *
         */
        setDrawerType({commit}, value) {
            commit('setDrawerType', value)
        },
        getBackendStatus({commit}) {
            $payedAPI({
                method: apiList.payedcourses.getFeedbackHealth.method,
                url: apiList.payedcourses.getFeedbackHealth.action
            }).then(resp => {
                commit('setBackendStatus', resp.status === 200 ? 'OK' : 'down')
            }).catch(err => {
                console.error('Backend is down or unreachable:', err)
                commit('setBackendStatus', 'down')
            })

        }
    }
}
